export enum DepotLoadingStates {
  LoadingDepot = 'Loading Depot Details...',
  UpdatingDepot = 'Saving Changes...',
  ReassigningManagers = 'Re-Assigning Managers...',
  RemovingDepot = 'Removing Depot...'
}